/* @flow */

import React from 'react';
import Relay from 'react-relay';
import { css } from 'glamor';

import DesktopOnly from '../DesktopOnly';
import MobileOnly from '../MobileOnly';

import { ZINDEX_NAVIGATION } from 'depop/styles/zIndex';

import Container from 'depop/components/layout/Container';

import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

class Header extends React.Component {
  props: {
    viewer: Object,
    isFixed: boolean,
  };

  render() {
    const { viewer, isFixed } = this.props;

    const opacity = isFixed ? 1 : 0;

    return (
      <div
        {...css({
          backgroundColor: '#fff',
          position: 'relative',
          zIndex: ZINDEX_NAVIGATION,
          borderBottom: `1px solid rgba(238,238,238, ${opacity})`,
        })}>
        <Container>
          <DesktopOnly>
            <DesktopHeader user={viewer.currentUser} />
          </DesktopOnly>
          <MobileOnly>
            <MobileHeader user={viewer.currentUser} />
          </MobileOnly>
        </Container>
      </div>
    );
  }
}

export default Relay.createContainer(Header, {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        currentUser {
          ${DesktopHeader.getFragment('user')}
          ${MobileHeader.getFragment('user')}
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/Header.js